<template>
  <div>
    <b-row align-h="center">
      <b-col xl="10" lg="10" md="12" sm="12">
        <top-card :user="user"></top-card>
        <Form/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Form from "./components/Form";
import TopCard from "./components/TopCard";

export default {
  name: "Profile",
  page() {
    return {
      title: this.$t('pages.profile.title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  components: {
    TopCard,
    Form
  },
  data() {
    return {
      user: {}
    }
  },
  mounted() {
    this.$auth.load().then(() => {
      this.user = this.$auth.user()
    })
  }
};
</script>

<style>


</style>
